import { Command, CommandRoot as Root } from 'cmdk';
import styled from 'styled-components';
import { caption, colors, duration, easing, extraLargeShadow, fonts, spacing } from 'ui/theme';
import { pxToRem } from 'utils/convert';

export const CommandRoot = styled(Root)`
  -webkit-font-smoothing: antialiased;
  max-width: ${pxToRem(672)};
  width: 100%;
  font-family: ${fonts.sansSerif};
  background: ${colors.backgroundPrimary};
  border-radius: ${spacing.half};
  overflow: hidden;
  ${extraLargeShadow};
  transition: transform ${duration.short} ${easing.exit};
`;

export const CommandList = styled(Command.List)`
  height: min(${spacing.x32}, calc(var(--cmdk-list-height)));
  max-height: ${spacing.x32};
  overflow: auto;
  overscroll-behavior: contain;
  transition: height ${duration.short} ${easing.exit};
  scrollbar-width: thin;
`;

export const CommandLoading = styled(Command.Loading)`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${spacing.base};
  min-height: ${spacing.x16};
`;

export const CommandGroup = styled(Command.Group)`
  /* Groups with no results have a hidden property added */
  &:not([hidden]) {
    display: flex;
    flex-direction: column;
    gap: ${spacing.half};
    padding: ${spacing.base};

    & ~ & {
      border-top: 1px solid ${colors.borderPrimarySubtle};
    }
  }

  /* label above list of items */
  [cmdk-group-heading] {
    ${caption}
    display: flex;
    align-items: center;
    color: ${colors.textDisabled};
    user-select: none;
  }

  /* container for list of items */
  [cmdk-group-items] {
    display: flex;
    flex-direction: column;
    gap: ${spacing.half};
  }
`;

/**
 * Single empty state shown when no total results,
 * Groups are hidden when no results are found
 */
export const CommandEmpty = styled(Command.Empty)`
  ${caption}
  display: flex;
  align-items: center;
  justify-content: left;
  padding: ${spacing.base};
  white-space: pre-wrap;
  color: ${colors.textDisabled};
`;

export const EmptyState = styled.div`
  ${caption}
  display: flex;
  align-items: center;
  justify-content: left;
  padding: ${spacing.base};
  white-space: pre-wrap;
  color: ${colors.textDisabled};
`;
